<app-header></app-header>
<main [class.with-footer]="footerVisible" [class]="footerClassName">
    <router-outlet></router-outlet>
</main>
